import ajax from '../../../../components/ajax';
import { useGetArchivedWorkoutsQuery } from '../../../../../generated/graphql';
import { SmartTableProps } from '@client/new/components/SmartTable/SmartTable';
import { toLiteWorkout } from '@client/new/pages/collection/workouts/workouts.hooks';
import { LiteWorkout } from '@client/new/pages/collection/workouts/workouts.domain';
import {
  WorkoutsSearchVM,
  buildWorkoutsListTable,
  filterWorkoutsByTitle,
  toProgramNameById,
} from './workoutTableExtras';
import {
  WorkoutsPagination,
  useWorkoutsPageData,
  useWorkoutsSearch,
} from './workoutsList.hooks';

type ArchivedWorkoutsVM = {
  isLoading: boolean;
  creator: { id: number };
  isEmpty: boolean;
  table: SmartTableProps<number>;
  search: WorkoutsSearchVM;
  pagination: WorkoutsPagination;
};

export const useArchivedWorkouts = (
  influencerIdParam?: string,
): ArchivedWorkoutsVM => {
  const { influencerId, isLoading, creator, workouts, refetch, pagination } =
    useWorkoutsPageData({
      influencerIdParam,
      useQuery: useGetArchivedWorkoutsQuery,
      selectWorkouts: (data) => data?.creator?.archivedWorkouts ?? [],
    });
  const { searchText, search } = useWorkoutsSearch();

  const liteWorkouts: LiteWorkout[] = workouts.map((w) =>
    toLiteWorkout(w, 'archived'),
  );

  const duplicate = (workoutId: number) => {
    if (confirm('Are you sure you want to *clone* this Workout?'))
      ajax.cloneWorkout(workoutId).then(refetch);
  };

  return {
    isLoading,
    creator,
    isEmpty: workouts.length === 0,
    table: {
      type: 'standard',
      value: buildWorkoutsListTable({
        kind: 'archived',
        influencerId,
        workouts: filterWorkoutsByTitle(liteWorkouts, searchText),
        programNameById: toProgramNameById(workouts),
        actions: { onDuplicate: duplicate },
      }),
    },
    search,
    pagination,
  };
};
